import { ArrowLeftSolidIcon, ArrowRightSolidIcon } from '@navi/web-ui/lib/icons';
import React, { useRef, useState } from 'react';
import styles from './index.module.scss';
import cx from 'classnames';
import ChevronRight from 'src/assets/icons/ChevronRight';
import ChevronLeft from 'src/assets/icons/ChevronLeft';
import { Button } from '@navi/web-ui/lib/primitives';

interface ICarouselProps {
  children: React.ReactNode;
  slidesWrapperClassName?: string;
  buttonWrapperVisibilityClass?: string;
  carouselSlideClass?: string;
  carouselWrapperClass?: string;
  carouselCTACallback?: () => void;
}
const Carousel = (props: ICarouselProps) => {
  const {
    children,
    slidesWrapperClassName,
    carouselWrapperClass,
    carouselSlideClass,
    buttonWrapperVisibilityClass,
    carouselCTACallback
  } = props;
  const carouselItems = React.Children.toArray(children).filter(Boolean);
  const [activeSlideIndex, setActiveSlideIndex] = useState<number>(0);
  const slidesWrapperRef = useRef<HTMLDivElement>(null);

  const scrollToIndex = (index: number) => {
    if (index < 0 || index > carouselItems.length - 1) {
      return;
    }
    const multiplier = slidesWrapperRef?.current?.children[activeSlideIndex].clientWidth || 0;
    setActiveSlideIndex(index);
    slidesWrapperRef?.current?.scrollTo({ left: index * multiplier, behavior: 'smooth' });
    if (carouselCTACallback) {
      carouselCTACallback();
    }
  };

  const isLastCarouselItem = activeSlideIndex === carouselItems.length - 1;
  if (!carouselItems.length) return null;

  return (
    <div className={cx(styles.carouselWrapper, carouselWrapperClass)}>
      {/* PREV BUTTON */}
      <Button
        variant="text"
        disabled={!activeSlideIndex}
        className={cx(styles.buttonWrapper, buttonWrapperVisibilityClass)}
        onClick={() => scrollToIndex(activeSlideIndex - 1)}
      >
        <ChevronLeft />
      </Button>

      {/* SLIDES */}
      <div
        ref={slidesWrapperRef}
        className={cx(slidesWrapperClassName, styles.carouselSlidesWrapper)}
      >
        {carouselItems?.map((items, index) => (
          <div key={index} className={cx(styles.carouselSlide, carouselSlideClass)}>
            {items}
          </div>
        ))}
      </div>

      {/* NEXT BUTTON */}
      <Button
        variant="text"
        disabled={isLastCarouselItem}
        className={cx(styles.buttonWrapper, buttonWrapperVisibilityClass)}
        onClick={() => scrollToIndex(activeSlideIndex + 1)}
      >
        <ChevronRight />
      </Button>
    </div>
  );
};

export default Carousel;
